"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.customStyles = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _async = _interopRequireDefault(require("react-select/async"));
var _polished = require("polished");
var _Option2 = _interopRequireDefault(require("./Option"));
var _selectors = require("../../shared/styles/themes/selectors");
var _styles = require("../../shared/styles");
var _Div = _interopRequireDefault(require("../Div"));
var _templateObject, _templateObject2;
var _excluded = ["hasIcon"],
  _excluded2 = ["placeholder", "isMulti", "icon", "async", "margin", "marginBottom", "colorType"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var customStyles = function customStyles(_ref) {
  var hasIcon = _ref.hasIcon,
    props = _objectWithoutProperties(_ref, _excluded);
  return {
    dropdownIndicator: function dropdownIndicator(styles, state) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        transition: 'all .2s ease',
        transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
        color: (0, _selectors.primaryColor)(props)
      });
    },
    indicatorSeparator: function indicatorSeparator(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        display: 'none'
      });
    },
    control: function control(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        border: 'none',
        borderRadius: 0,
        borderBottom: "2px solid ".concat((0, _selectors.formBorderColor)(props)),
        background: 'transparent',
        overflow: 'hidden',
        ':hover': {
          borderBottom: "2px solid ".concat((0, _selectors.formBorderColor)(props))
        }
      });
    },
    input: function input(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        margin: 0
      });
    },
    placeholder: function placeholder(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        color: (0, _selectors.getField)('select.placeholderColor', props),
        width: 'calc(100% - 10px)',
        overflow: 'hidden',
        '-o-text-overflow': 'ellipsis',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      });
    },
    option: function option(styles, _ref2) {
      var isSelected = _ref2.isSelected;
      var accentColor = (0, _selectors.getField)("select.accentColor", props);
      var optionColor = (0, _selectors.getField)("select.option.".concat(isSelected ? 'selected' : 'unselected', ".color"), props);
      var optionBackgroundColor = (0, _selectors.getField)("select.option.".concat(isSelected ? 'selected' : 'unselected', ".backgroundColor"), props);
      return _objectSpread(_objectSpread({}, styles), {}, {
        color: optionColor,
        backgroundColor: optionBackgroundColor,
        padding: '12px 15px',
        ':hover': {
          background: (0, _polished.lighten)(0.1, accentColor)
        }
      });
    },
    valueContainer: function valueContainer(styles, state) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        paddingLeft: hasIcon ? '30px' : '12px',
        zIndex: state.selectProps.menuIsOpen && 15
      });
    },
    multiValue: function multiValue(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        backgroundColor: (0, _selectors.getField)("select.accentColor", props),
        borderRadius: '15px',
        padding: '2px'
      });
    },
    multiValueLabel: function multiValueLabel(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        color: (0, _selectors.getField)("select.option.selected.color", props)
      });
    },
    multiValueRemove: function multiValueRemove(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        color: (0, _selectors.getField)("select.option.selected.color", props),
        ':hover': {
          color: (0, _selectors.getField)("select.option.selected.color", props)
        }
      });
    },
    clearIndicator: function clearIndicator(styles, state) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        color: 'inherit',
        zIndex: state.selectProps.menuIsOpen && 3
      });
    },
    menu: function menu(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        marginTop: 0,
        border: 'none',
        zIndex: 14,
        borderRadius: 0,
        overflow: 'hidden'
      });
    },
    menuList: function menuList(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        padding: 0
      });
    },
    singleValue: function singleValue(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        color: (0, _selectors.color)(props)
      });
    }
  };
};
exports.customStyles = customStyles;
var IconWrap = (0, _styledComponents["default"])(_Div["default"])(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n"])));
var Wrap = (0, _styledComponents["default"])(_Div["default"])(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  ", "\n  ", "\n"])), (0, _styles.letterSpacing)(), _styles.addCssProp);
var Select = function Select(_ref3) {
  var placeholder = _ref3.placeholder,
    isMulti = _ref3.isMulti,
    icon = _ref3.icon,
    async = _ref3.async,
    margin = _ref3.margin,
    marginBottom = _ref3.marginBottom,
    colorType = _ref3.colorType,
    rest = _objectWithoutProperties(_ref3, _excluded2);
  var Component = (0, _react.useMemo)(function () {
    return async ? _async["default"] : _reactSelect["default"];
  }, [async]);
  var hasIcon = (0, _react.useMemo)(function () {
    return !!icon;
  }, [icon]);
  return /*#__PURE__*/_react["default"].createElement(Wrap, {
    margin: margin,
    marginBottom: marginBottom
  }, /*#__PURE__*/_react["default"].createElement(IconWrap, null, icon), /*#__PURE__*/_react["default"].createElement(Component, _extends({
    styles: customStyles(_objectSpread({
      hasIcon: hasIcon,
      colorType: colorType
    }, rest)),
    placeholder: placeholder,
    hideSelectedOptions: false,
    closeMenuOnSelect: !isMulti,
    blurInputOnSelect: !isMulti,
    isMulti: isMulti,
    components: {
      Option: function Option(inputProps) {
        return /*#__PURE__*/_react["default"].createElement(_Option2["default"], _extends({
          colorType: colorType
        }, inputProps));
      }
    }
  }, rest)));
};
Select.propTypes = {
  colorType: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  isMulti: _propTypes["default"].bool,
  async: _propTypes["default"].bool,
  icon: _propTypes["default"].node,
  margin: _propTypes["default"].object,
  marginBottom: _propTypes["default"].string
};
var _default = (0, _styledComponents.withTheme)(Select);
exports["default"] = _default;